<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="sidebar_wrp">
  <p-sidebar
    #sidebarRef
    [(visible)]="sidebarVisible"
    [closeOnEscape]="false"
    [showCloseIcon]="false">
    <ng-template pTemplate="headless">
      <div class="flex flex-column h-full sidebar_sc">
        <div
          class="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0 logo_main">
          <figure
            (click)="onLogoClick()"
            [routerLink]="['/dashboard']"
            routerLinkActive="router-link-active"
            class="inline-flex align-items-center gap-2 logo cp">
            <img src="assets/images/logo1.png" alt="logo" />
            <figcaption>{{ 'LOGIBIDS' | translate }}</figcaption>
          </figure>
        </div>

        <div class="overflow-y-auto my-4">
          <ul class="list-none p-0 m-0 overflow-hidden">
            @for (items of sideBar; track $index) {
              @if (
                !items.isSubMenu && items.sidebar_module !== moduleConst.Profile
              ) {
                <li
                  class="function_li"
                  [ngClass]="{ active: items.active }"
                  (click)="toggleActive(items, null)"
                  [routerLink]="items.path">
                  <a
                    pRipple
                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                    <figure>
                      <img [src]="items.icon" alt="" />
                    </figure>
                    <span>{{ items.label | translate }}</span>
                  </a>
                </li>
              } @else if (items.sidebar_module !== moduleConst.Profile) {
                <li>
                  <!-- slideup -->
                  <a
                    pRipple
                    (click)="deSelectItems(items); $event.stopPropagation()"
                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                    <figure>
                      <img [src]="items.icon" alt="" />
                    </figure>
                    <span>{{ items.label | translate }}</span>
                    <i
                      class="pi pi-chevron-right ml-auto"
                      [ngClass]="{
                        'rotate-90': expandedSubMenus.has(items.sidebar_module),
                      }"></i>
                  </a>
                  <ul
                    class="list-none submenu py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out"
                    [ngClass]="{
                      hidden: !expandedSubMenus.has(items.sidebar_module),
                    }">
                    @for (subitems of items.subMenuItems; track $index) {
                      @if (
                        !subitems.isSubMenu &&
                        subitems.sidebar_module !== moduleConst.Profile
                      ) {
                        <li
                          [routerLink]="subitems.path"
                          [ngClass]="{ active: subitems.active }"
                          (click)="toggleActive(items, subitems)">
                          <a
                            pRipple
                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                            <figure>
                              <img [src]="subitems.icon" alt="" />
                            </figure>
                            <span>{{ subitems.label | translate }}</span>
                          </a>
                        </li>
                      } @else if (
                        subitems.sidebar_module !== moduleConst.Profile
                      ) {
                        <li>
                          <!-- slideup -->
                          <a
                            pRipple
                            (click)="
                              deSelectItems(subitems); $event.stopPropagation()
                            "
                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                            <figure>
                              <img [src]="subitems.icon" alt="" />
                            </figure>
                            <span>{{ subitems.label | translate }}</span>
                            <i
                              class="pi pi-chevron-right ml-auto"
                              [ngClass]="{
                                'rotate-90': expandedSubMenus.has(
                                  subitems.sidebar_module
                                ),
                              }"></i>
                          </a>
                          <ul
                            class="list-none submenu py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out"
                            [ngClass]="{
                              hidden: !expandedSubMenus.has(
                                subitems.sidebar_module
                              ),
                            }">
                            @for (
                              subitemsSub of subitems.subModules;
                              track $index
                            ) {
                              <li
                                [routerLink]="subitemsSub.path"
                                [ngClass]="{ active: subitemsSub.active }"
                                (click)="
                                  toggleActive(items, subitems, subitemsSub)
                                ">
                                <a
                                  pRipple
                                  class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                  <figure>
                                    <img [src]="subitemsSub.icon" alt="" />
                                  </figure>
                                  <span>{{
                                    subitemsSub.label | translate
                                  }}</span>
                                </a>
                              </li>
                            }
                          </ul>
                        </li>
                      }
                    }
                  </ul>
                </li>
              }
            }
          </ul>
        </div>

        <div
          (click)="btn_logOut()"
          routerLinkActive="router-link-active"
          class="mt-auto">
          <hr class="mb-3 mx-3 border-top-1 border-none surface-border" />
          <a
            pRipple
            class="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            @if (profile) {
              <p-avatar icon="pi pi-sign-out" shape="circle" />
            }
            <span class="font-bold">{{ 'Logout' | translate }}</span>
          </a>
        </div>
      </div>
    </ng-template>
  </p-sidebar>
</div>
